import Icon from '../Icon.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ExternalWalletHeader(props) {
  const {
    title,
    goBack,
    closeModal,
    disableBackButton
  } = props;
  return /*#__PURE__*/jsxs("div", {
    className: "w3a--flex w3a--flex-row w3a--justify-center w3a--items-center w3a--gap-1",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a--flex-grow-1 w3a--flex-shrink-0 w3a--items-center w3a--justify-start w3a--mr-auto",
      children: !disableBackButton && /*#__PURE__*/jsx("button", {
        type: "button",
        className: "w3a-external-back w3ajs-external-back",
        onClick: goBack,
        children: /*#__PURE__*/jsx(Icon, {
          iconName: "arrow-left-light",
          darkIconName: "arrow-left-dark",
          width: "16",
          height: "16"
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "w3a-header__title w3a--flex-grow-0 w3a--flex-shrink w3a--truncate w3a--mr-6",
      children: title
    }), /*#__PURE__*/jsx("div", {
      className: "w3a--flex-grow-1 w3a--flex-shrink-0 w3a--items-center w3a--justify-end w3a--ml-auto",
      children: /*#__PURE__*/jsx("button", {
        type: "button",
        onClick: closeModal,
        className: "w3a-header__button_wallet w3ajs-close-btn",
        children: /*#__PURE__*/jsx(Icon, {
          iconName: "x-light",
          darkIconName: "x-dark"
        })
      })
    })]
  });
}

export { ExternalWalletHeader as default };
